module.exports = __webpack_public_path__ + "img/DT-logo-white.8efbb663.svg";